export enum ProductLogType {
  DELIVERY = 1,
  DELIVERY_REVERSED = 2,
  PRODUCTION = 3,
  PRODUCTION_UPDATE = 4,
  PRODUCTION_DELETE = 5,
  RESET = 6,
}

export const ProductLogTypeLabels: Record<ProductLogType, string> = {
  [ProductLogType.DELIVERY]: 'Delivery',
  [ProductLogType.DELIVERY_REVERSED]: 'Delivery Reversed',
  [ProductLogType.PRODUCTION]: 'Production',
  [ProductLogType.PRODUCTION_UPDATE]: 'Production Update',
  [ProductLogType.PRODUCTION_DELETE]: 'Production Delete',
  [ProductLogType.RESET]: 'Reset',
};
